import BaseRepository from "./BaseRepository";
import ForecastAPICall from "../service/ForecastAPICall";

class ForecastRepository extends BaseRepository {
    getForecastData = async (params) => {
        return await new ForecastAPICall().getForecastData(params);
    };

    forecastShare = async (sendToEmails, subject, message, filterOption) => {
        return await new ForecastAPICall().forecastShare({
            sendToEmails, subject, message, filterOption
        });
    };

    getForecastCount = async() => {
        return await new ForecastAPICall().getForecastCount();
    }

    downloadForecast = async(params) => {
        return await new ForecastAPICall().downloadForecast(params);
    }
}

export default ForecastRepository;